import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useParams, useLocation } from "react-router-dom";
import { Button, Form, FormGroup, Label, FormText, Row, Col, Alert, Table, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Card, TextField } from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { showSuccessToast, showErrorToast } from "../../../../_services/notification";
import {
  postMethod
} from "../../../../_services/_postMethod";
import Loader from "../../../modules/loader";
import { useHistory } from "react-router-dom";


function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function AddProductStock() {

 const formatDateTime = (dateTime) => {
  if (!dateTime) return "-";

  const value = String(dateTime).trim();

  const normalized = value.replace("T", " ").replace("Z", "");

  const [datePart, timePart] = normalized.split(" ");

  if (!datePart) return value;

  const [year, month, day] = datePart.split("-");

  if (!year || !month || !day) {
    return value;
  }

  const time = timePart
    ? timePart.substring(0, 5)
    : "00:00";

  return `${day}-${month}-${year} ${time}`;
};
  
  const history = useHistory();
  // -----------
  let queryParams = useQuery();
  const id = queryParams.get("id") == "" ? null : queryParams.get("id");
  const isViewMode = id !== null;
  const jwl_branch_id = localStorage.getItem("jwl_branch_id");
  const { register, handleSubmit, errors } = useForm();
  const [load, setLoad] = useState(false);
  const [loadInser, setLoadInsert] = useState(false);
  const [loadDelete, setLoadDelete] = useState(false);
  const [loadDeleteMsg, setLoadDeleteMsg] = useState("Deleted");
  const [productsValidation, setProductsValidation] = useState(false);
  const [productlist, setProductlist] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [searchProduct, setSearchProduct] = useState("");
  const [seachProdutListLoading, setseachProdutListLoading] = useState(false);
  // -------------
  // const [param, setParam] = useState({
  //   tran_id: id == null ? "0" : id,
  //   to_branch_id: 0,
  // title:"",
  // staff_name:"",
  //   remarks: "",
  //   add_qty:1,
  //   status: "",
  //   stock_in_products: [],
  // });

  const [param, setParam] = useState({
    tran_id: id == null ? "0" : id,
    to_branch_id: 0,
    title: "",
    staff_id: "",
    staff_name: "",
    remarks: "",
    add_qty: 1,
    status: "",
    stock_in_products: [],
  });
  const [success, setSuccess] = useState(false);
  const [successDelete, setSuccessDelete] = useState(false);

  const [negativeConfirmModal, setNegativeConfirmModal] = useState(false);
  const [pendingAction, setPendingAction] = useState(null);
  const [searchedProducts, setSearchedProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  // Update Qty
  // const updateQty = (id, qty) => {

  //   const product = searchedProducts.find((x) => x.id === id);

  //   if (!product) return;

  //   if (qty > product.qty) {
  //     showErrorToast("Qty is not more than available qty.");
  //     return;
  //   }

  //   setSearchedProducts((prev) =>
  //     prev.map((item) =>
  //       item.id === id
  //         ? {
  //             ...item,
  //             add_qty: qty,
  //           }
  //         : item
  //     )
  //   );

  //   setSelectedProducts((prev) =>
  //     prev.map((item) =>
  //       item.id === id
  //         ? {
  //             ...item,
  //             add_qty: qty,
  //           }
  //         : item
  //     )
  //   );
  // };

  const updateQty = (product_id, qty) => {
    if (isViewMode) return;
    const product = searchedProducts.find(
      (x) => x.product_id === product_id
    );

    if (!product) return;

    // Empty or bare minus allow while typing
    if (qty === "" || qty === "-") {
      setSearchedProducts((prev) =>
        prev.map((item) =>
          item.product_id === product_id
            ? { ...item, add_qty: qty }
            : item
        )
      );

      setSelectedProducts((prev) =>
        prev.map((item) =>
          item.product_id === product_id
            ? { ...item, add_qty: qty }
            : item
        )
      );

      return;
    }

    // Digits and optional leading minus allow
    if (!/^-?\d*$/.test(qty)) {
      return;
    }

    setSearchedProducts((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? {
            ...item,
            add_qty: qty,
          }
          : item
      )
    );

    setSelectedProducts((prev) =>
      prev.map((item) =>
        item.product_id === product_id
          ? {
            ...item,
            add_qty: qty,
          }
          : item
      )
    );
  };
  const [historyLoading, setHistoryLoading] = useState({});

  const toggleHistory = async (product_id) => {
    if (expandedRows[product_id]) {
      setExpandedRows((prev) => ({
        ...prev,
        [product_id]: false,
      }));
      return;
    }

    const product = searchedProducts.find(
      (x) => x.product_id === product_id
    );

    if (!product?.historyLoaded) {
      try {
        setHistoryLoading((prev) => ({
          ...prev,
          [product_id]: true,
        }));
        const res = await postMethod(
          "api/transactions/product/stock_history/by_branch", { product_id }
        );

        setSearchedProducts((prev) =>
          prev.map((item) =>
            item.product_id === product_id
              ? {
                ...item,
                history: res.data || [],
                historyLoaded: true,
              }
              : item
          )
        );
      } catch (err) {
        showErrorToast("Unable to load stock history");
      } finally {
        setHistoryLoading((prev) => ({
          ...prev,
          [product_id]: false,
        }));
      }
    }

    setExpandedRows((prev) => ({
      ...prev,
      [product_id]: true,
    }));
  };
  // Checkbox

  // Selected Products
  const selected = selectedProducts;

  // Save
  const executeSaveStock = async () => {
    setLoadInsert(true);

    const payload = {
      tran_id: Number(param.tran_id),
      title: param.title,
      staff_id: Number(param.staff_id || 0),
      remarks: param.remarks,
      stock_in_products: selectedProducts.map((item) => ({
        product_id: Number(item.product_id),
        qty: Number(item.add_qty),
      })),
    };

    console.log(payload);

    try {
      const res = await postMethod(
        "api/transactions/product/adjust_stockin/by_branch",
        payload
      );

      if (res.success || res.status === true) {
        showSuccessToast(res.message || "Stock added successfully.");

        // Optional
        setSelectedProducts([]);
        setSearchedProducts([]);
        setSearchProduct("");

        history.push("/branch/stock-in");
      } else {
        showErrorToast(res.message || "Something went wrong.");
      }
    } catch (err) {
      console.log(err);
      showErrorToast("Server Error");
    } finally {
      setLoadInsert(false);
    }
  };

  const handleSave = async () => {
    if (isViewMode) {
      return;
    }

    // Stock Adjustment Permission
    if (
      branchDetails &&
      (
        branchDetails[0].stock_add_permission === false ||
        branchDetails[0].stock_add_permission === 0 ||
        branchDetails[0].stock_add_permission === "0"
      )
    ) {
      showErrorToast(
        "You do not have permission to adjust stock."
      );
      return;
    }

    if (selectedProducts.length === 0) {
      showErrorToast("Please select at least one product.");
      return;
    }

    const hasNegative = selectedProducts.some(
      (item) => Number(item.add_qty) < 0
    );

    if (hasNegative) {
      setPendingAction({ type: "save" });
      setNegativeConfirmModal(true);
      return;
    }

    executeSaveStock();
  };

  const handleConfirmNegative = () => {
    setNegativeConfirmModal(false);
    if (!pendingAction) return;

    if (pendingAction.type === "save") {
      executeSaveStock();
    } else if (pendingAction.type === "toggle" && pendingAction.product) {
      performSelectProduct(pendingAction.product);
    }
    setPendingAction(null);
  };

  const handleCancelNegative = () => {
    setNegativeConfirmModal(false);
    setPendingAction(null);
  };

  // ------------------All Function-------------------------
  // -Search
  const searchProductFun = () => {
    setseachProdutListLoading(true);

    postMethod("api/transactions/customer/session/getProductsbyProductCode", {
      search: searchProduct,
    })
      .then((data) => {
        if (!data.data || data.data.length === 0) {
          setSearchedProducts([]);
          showErrorToast("Product does not exist.");
          return;
        }

        const products = data.data.map((item) => {
          const selected = selectedProducts.find(
            (x) => x.product_id === item.product_id
          );

          return {
            ...item,
            checked: !!selected,
            add_qty: selected ? selected.add_qty : "",
            history: [],
            historyLoaded: false,
          };
        });

        setSearchedProducts(products);
      })
      .finally(() => {
        setseachProdutListLoading(false);
      });
  };

  const performSelectProduct = (product) => {
    setSelectedProducts((prev) => [
      ...prev,
      {
        ...product,
        checked: true,
        add_qty: Number(product.add_qty || 0),
      },
    ]);

    setSearchedProducts((prev) =>
      prev.map((item) =>
        item.product_id === product.product_id
          ? {
              ...item,
              checked: true,
            }
          : item
      )
    );
  };

  const toggleProduct = (product_id) => {
    if (isViewMode) return;
    const product = searchedProducts.find(
      (x) => x.product_id === product_id
    );

    if (!product) return;

    const alreadySelected =
      selectedProducts.findIndex(
        (x) => x.product_id === product_id
      ) > -1;

    if (!alreadySelected) {
      const qty = Number(product.add_qty);

      if (
        product.add_qty === "" ||
        product.add_qty === "-" ||
        product.add_qty === null ||
        product.add_qty === undefined ||
        isNaN(qty)
      ) {
        showErrorToast("Please enter quantity.");
        return;
      }

      if (qty === 0) {
        showErrorToast("Quantity cannot be zero.");
        return;
      }

      if (qty < 0) {
        setPendingAction({ type: "toggle", product });
        setNegativeConfirmModal(true);
        return;
      }

      performSelectProduct(product);
    } else {
      setSelectedProducts((prev) =>
        prev.filter((x) => x.product_id !== product_id)
      );

      setSearchedProducts((prev) =>
        prev.map((item) =>
          item.product_id === product_id
            ? {
                ...item,
                checked: false,
              }
            : item
        )
      );
    }
  };

  const [staffList, setStaffList] = useState([]);
  const [branchDetails, setBranchDetails] = useState([]);

  const getStaffList = async () => {
    try {
      const res = await postMethod("api/customervisit/StaffList");
      setStaffList(res.data);
    } catch (error) {
      console.error("Error fetching staff list:", error);
    }
  };

  const getBranchDetail = async () => {
    try {
      const res = await postMethod("api/customervisit/get_branch_logo");
      setBranchDetails(res.data);
    } catch (error) {
      console.error("Error fetching branch details:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          getStaffList(),
          getBranchDetail(),
        ]);

        if (isViewMode) {
          await getPreview();
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);
  const getImage = (item) => {
    if (!item) return "";
    let path = item.image_path || "";
    let baseUrl = item.url_image || "https://admin.quicktagg.com/";

    if (item.isImageUrl === true || item.isImageUrl === "true") {
      if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
        return path;
      }
      return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
    }

    if (path.startsWith("http://") || path.startsWith("https://") || path.startsWith("data:")) {
      return path;
    }

    return baseUrl.replace(/\/$/, "") + "/" + path.replace(/^\//, "");
  };

  const loadImageAsBase64 = async (src) => {
    if (!src) return null;
    try {
      const res = await fetch(src);
      if (res.ok) {
        const blob = await res.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve(null);
          reader.readAsDataURL(blob);
        });
      }
    } catch (e) {}

    return new Promise((resolve) => {
      const corsSrc = src.includes("data:") ? src : src + (src.includes("?") ? "&" : "?") + "cb=" + Date.now();
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width || 60;
          canvas.height = img.naturalHeight || img.height || 60;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          const dataUrl = canvas.toDataURL("image/jpeg", 0.85);
          resolve(dataUrl);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = corsSrc;
    });
  };
  // -------------------------------------------------------


  // ---------------Preiew

  const getPreview = async () => {
    try {
      setLoad(true);

      const tran_id = window.atob(id);

      const res = await postMethod("api/transactions/stockin/preview", {
        tran_id,
      });

      if (!res || !res.data) return;

      const response = res.data;
      const header = response.header?.[0] || {};

      setParam((prev) => ({
        ...prev,
        tran_id: header.tran_id || "",
        title: header.title || "",
        remarks: header.remark || "",
        staff_id: header.staff_id || "",
      }));

      const products = (response.products || []).map((item) => ({
        ...item,
        checked: true,
        add_qty: item.add_qty || 0,
        history: [],
        historyLoaded: false,
      }));

      setSelectedProducts(products);
    } catch (err) {
      console.error(err);
      showErrorToast("Unable to load stock.");
    } finally {
      setLoad(false);
    }
  };

  const exportToExcel = () => {
    try {
      const selectedStaff = staffList.find((s) => String(s.staff_id) === String(param.staff_id))?.name || param.staff_name || "-";

      const sheetData = [
        ["Title", param.title || "-"],
        ["Staff Name", selectedStaff],
        ["Remarks", param.remarks || "-"],
        [],
        [`Selected Products (${selectedProducts.length} Items)`],
        ["Product Code", "Name", "Gender", "Color", "Size", "Price", "Available Qty", "Qty"],
        ...selectedProducts.map((item) => [
          item.product_code || "",
          item.product_name || "",
          item.gender || "",
          item.color || "",
          item.size_length || "",
          item.price ? `₹ ${item.price}` : "",
          item.qty ?? "",
          item.add_qty ?? "",
        ]),
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Stock_In_Products");
      const filename = `Stock_In_${param.title || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.xlsx`;
      XLSX.writeFile(workbook, filename);
      showSuccessToast("Excel downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating Excel file.");
    }
  };

  const exportToPDF = async () => {
    try {
      setLoad(true);
      const pdf = new jsPDF("p", "mm", "a4");
      let y = 15;

      const selectedStaff = staffList.find((s) => String(s.staff_id) === String(param.staff_id))?.name || param.staff_name || "-";

      pdf.setFontSize(10);
      pdf.setFont(undefined, "normal");
      pdf.text(`Title: ${param.title || "-"}`, 14, y);
      pdf.text(`Staff Name: ${selectedStaff}`, 85, y);
      y += 6;
      pdf.text(`Remarks: ${param.remarks || "-"}`, 14, y);
      y += 8;

      pdf.setFont(undefined, "bold");
      pdf.text(`Selected Products (${selectedProducts.length} Items)`, 14, y);
      y += 6;

      // Table Headers
      pdf.setFontSize(8);
      pdf.setFont(undefined, "bold");
      pdf.setFillColor(240, 243, 246);
      pdf.rect(14, y - 4, 181, 6, "F");

      const colPositions = [15, 48, 78, 98, 115, 132, 150, 168, 182];
      const headers = ["Product Code", "Name", "Gender", "Color", "Size", "Price", "Available", "Qty", "Image"];
      headers.forEach((h, idx) => {
        pdf.text(h, colPositions[idx], y);
      });

      y += 4;
      pdf.line(14, y - 1, 195, y - 1);
      y += 4;

      // Pre-load images
      const loadedImages = await Promise.all(
        selectedProducts.map((item) => loadImageAsBase64(getImage(item)))
      );

      pdf.setFont(undefined, "normal");
      for (let index = 0; index < selectedProducts.length; index++) {
        const item = selectedProducts[index];
        const imgData = loadedImages[index];
        const rowHeight = imgData ? 13 : 7;

        if (y + rowHeight > 275) {
          pdf.addPage();
          y = 15;
        }

        const textY = imgData ? y + 5 : y;
        pdf.text(String(item.product_code || "-"), colPositions[0], textY, { maxWidth: 30 });
        pdf.text(String(item.product_name || "-"), colPositions[1], textY, { maxWidth: 28 });
        pdf.text(String(item.gender || "-"), colPositions[2], textY, { maxWidth: 18 });
        pdf.text(String(item.color || "-"), colPositions[3], textY, { maxWidth: 15 });
        pdf.text(String(item.size_length || "-"), colPositions[4], textY, { maxWidth: 15 });
        pdf.text(item.price ? `₹ ${item.price}` : "-", colPositions[5], textY, { maxWidth: 16 });
        pdf.text(String(item.qty ?? "-"), colPositions[6], textY, { maxWidth: 15 });
        pdf.text(String(item.add_qty ?? "-"), colPositions[7], textY, { maxWidth: 12 });

        if (imgData) {
          try {
            const format = imgData.includes("image/png") ? "PNG" : "JPEG";
            pdf.addImage(imgData, format, colPositions[8], y, 10, 10);
          } catch (e) {
            pdf.text("-", colPositions[8], textY);
          }
        } else {
          pdf.text("-", colPositions[8], textY);
        }

        y += rowHeight + 2;
      }

      const filename = `Stock_In_${param.title || param.tran_id || "Details"}_${moment().format("DD-MM-YYYY")}.pdf`;
      pdf.save(filename);
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating PDF file.");
    } finally {
      setLoad(false);
    }
  };

  const fetchProductHistory = async (product_id) => {
    try {
      const res = await postMethod(
        "api/transactions/product/stock_history/by_branch",
        { product_id }
      );
      return res.data || [];
    } catch (err) {
      console.error(err);
      return [];
    }
  };

  const downloadRowExcel = async (item) => {
    try {
      setLoad(true);
      const historyData = (item.history && item.history.length > 0)
        ? item.history
        : await fetchProductHistory(item.product_id);

      const sheetData = [
        ["PRODUCT DETAILS"],
        ["Product Code", item.product_code || "-"],
        ["Product Name", item.product_name || "-"],
        ["Gender", item.gender || "-"],
        ["Color", item.color || "-"],
        ["Size", item.size_length || "-"],
        ["Price", item.price ? `₹ ${item.price}` : "-"],
        ["Available Qty", item.qty ?? "-"],
        ["Selected Qty", item.add_qty ?? "-"],
        [],
        ["PRODUCT STOCK HISTORY"],
        ["S.No", "Type", "From Branch", "To Branch", "Cancelled By Branch", "Qty", "Current Qty", "Date Time"],
      ];

      if (historyData.length === 0) {
        sheetData.push(["No History Found"]);
      } else {
        historyData.forEach((row, i) => {
       
          sheetData.push([
            i + 1,
            row.tran_type || "-",
            row.from_branch || "-",
            row.to_branch || "-",
            row.cancelled_branch || "-",
            row.qty ?? "-",
            row.RunningStock ?? "-",
            formatDateTime(row.datetime),
          ]);
        });
      }

      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Product_History");
      const cleanCode = (item.product_code || item.product_id || "product").replace(/[\/\\?%*:|"<>]/g, "_");
      XLSX.writeFile(workbook, `Product_${cleanCode}_History.xlsx`);
      showSuccessToast("Excel downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating Excel.");
    } finally {
      setLoad(false);
    }
  };

  const downloadRowPDF = async (item) => {
    try {
      setLoad(true);
      const historyData = (item.history && item.history.length > 0)
        ? item.history
        : await fetchProductHistory(item.product_id);

      const imgData = await loadImageAsBase64(getImage(item));

      const pdf = new jsPDF("p", "mm", "a4");
      let y = 15;

      pdf.setFontSize(14);
      pdf.setFont(undefined, "bold");
      pdf.text("Product Details & Stock History", 14, y);
      y += 8;

      pdf.setLineWidth(0.3);
      pdf.line(14, y, 195, y);
      y += 8;

      // Product Info Box + Image
      const startInfoY = y;
      if (imgData) {
        try {
          pdf.addImage(imgData, "JPEG", 14, y, 25, 25);
        } catch (e) {}
      }

      const infoX = imgData ? 45 : 14;
      pdf.setFontSize(10);
      pdf.setFont(undefined, "bold");
      pdf.text(`Product Code: ${item.product_code || "-"}`, infoX, y);
      pdf.text(`Product Name: ${item.product_name || "-"}`, infoX + 75, y);
      y += 6;

      pdf.setFont(undefined, "normal");
      pdf.text(`Gender: ${item.gender || "-"}`, infoX, y);
      pdf.text(`Color: ${item.color || "-"}`, infoX + 40, y);
      pdf.text(`Size: ${item.size_length || "-"}`, infoX + 75, y);
      y += 6;

      pdf.text(`Price: ${item.price ? `₹ ${item.price}` : "-"}`, infoX, y);
      pdf.text(`Available Qty: ${item.qty ?? "-"}`, infoX + 40, y);
      pdf.text(`Selected Qty: ${item.add_qty ?? "-"}`, infoX + 75, y);
      y += 12;

      if (imgData && y < startInfoY + 30) {
        y = startInfoY + 30;
      }

      // History Section
      pdf.setFontSize(11);
      pdf.setFont(undefined, "bold");
      pdf.text("Stock History", 14, y);
      y += 6;

      pdf.setFontSize(8);
      pdf.setFillColor(240, 243, 246);
      pdf.rect(14, y - 4, 181, 6, "F");

      const colPositions = [15, 28, 55, 82, 115, 140, 158, 172];
      const headers = ["S.No", "Type", "From Branch", "To Branch", "Cancelled Branch", "Qty", "Current Qty", "Date Time"];
      headers.forEach((h, idx) => {
        pdf.text(h, colPositions[idx], y);
      });

      y += 4;
      pdf.line(14, y - 1, 195, y - 1);
      y += 4;

      pdf.setFont(undefined, "normal");
      if (historyData.length === 0) {
        pdf.text("No History Found", 14, y);
        y += 6;
      } else {
        historyData.forEach((row, i) => {
          if (y > 275) {
            pdf.addPage();
            y = 15;
          }

      const formattedDate = formatDateTime(row.datetime);
          pdf.text(String(i + 1), colPositions[0], y);
          pdf.text(String(row.tran_type || "-"), colPositions[1], y, { maxWidth: 24 });
          pdf.text(String(row.from_branch || "-"), colPositions[2], y, { maxWidth: 24 });
          pdf.text(String(row.to_branch || "-"), colPositions[3], y, { maxWidth: 30 });
          pdf.text(String(row.cancelled_branch || "-"), colPositions[4], y, { maxWidth: 22 });
          pdf.text(String(row.qty ?? "-"), colPositions[5], y);
          pdf.text(String(row.RunningStock ?? "-"), colPositions[6], y);
          pdf.text(formattedDate, colPositions[7], y, { maxWidth: 24 });

          y += 6;
        });
      }

      const cleanCode = (item.product_code || item.product_id || "product").replace(/[\/\\?%*:|"<>]/g, "_");
      pdf.save(`Product_${cleanCode}_History.pdf`);
      showSuccessToast("PDF downloaded successfully.");
    } catch (err) {
      console.error(err);
      showErrorToast("Error generating PDF.");
    } finally {
      setLoad(false);
    }
  };

  // -----------------------
  return (
    <div className="stockin-page">
      <div className="stockin-card">

        {/* Header */}
        <div className="stockin-header d-flex align-items-center justify-content-between flex-wrap">
          <div>
            <h2>{isViewMode ? "View" : "Add"} Product Stock</h2>
            <p>Record customer purchase details and selected products.</p>
          </div>
          {isViewMode && (
            <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: "10px" }}>
              <button
                type="button"
                className="btn btn-outline-danger btn-sm font-weight-bold py-2 px-3"
                onClick={exportToPDF}
              >
                <i className="fa fa-file-pdf-o mr-2"></i> Download PDF
              </button>
              <button
                type="button"
                className="btn btn-outline-success btn-sm font-weight-bold py-2 px-3"
                onClick={exportToExcel}
              >
                <i className="fa fa-file-excel-o mr-2"></i> Download Excel
              </button>
            </div>
          )}
        </div>

        {/* Form */}
        <div className="row g-3 mb-4">

          <div className="col-md-4">
            <label className="form-label">Title</label>
            <input
              type="text"
              className="form-control"
              disabled={isViewMode}
              value={param.title}
              onChange={(e) =>
                setParam({
                  ...param,
                  title: e.target.value,
                })
              }
            />
          </div>

          <div className="col-md-4">
            <FormGroup>
              <Label>Staff Name</Label>
              <select
                className="form-control h-auto py-2 px-6"
                onChange={(e) =>
                  setParam({ ...param, staff_id: e.target.value })
                }
                name="staff_id"
                value={param.staff_id}
                disabled={isViewMode}

              >
                <option value="">--Select--</option>
                {staffList.map((prop, i) => (
                  <option key={i} value={prop.staff_id}>
                    {prop.name}
                  </option>
                ))}
              </select>
            </FormGroup>
          </div>

          <div className="col-md-4">
            <label className="form-label">Remarks</label>
            <textarea
              rows="1"
              className="form-control"
              disabled={isViewMode}
              value={param.remarks}
              onChange={(e) =>
                setParam({
                  ...param,
                  remarks: e.target.value,
                })
              }
            />
          </div>

        </div>

        {/* Search Card */}

        {!isViewMode && (
          <div className="stockin-search-card">

            <div className="stockin-search-header">

              <div>
                <h3>Searched Products</h3>
                <span>Search by product code and choose items.</span>
              </div>

              <div className="d-flex gap-2 align-items-stretch">

                <input
                  type="text"
                  value={searchProduct}
                  className="form-control mr-2"
                  placeholder="Search Product"
                  onChange={(e) => setSearchProduct(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      searchProductFun();
                    }
                  }}
                />
                {seachProdutListLoading ? (
                  <button
                    type="button"
                    className="btn btn-secondary h-100"
                    disabled
                  >
                    Searching...
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-success customer-sales-editor-inline-btn h-100"
                    onClick={() => {
                      searchProductFun();
                    }}
                  >
                    Search
                  </button>
                )}

              </div>

            </div>

            <div className="table-responsive">

              <table className="table table-bordered table-hover align-middle stockin-table">

                <thead>

                  <tr>
                    <th>Product Code</th>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Color</th>
                    <th>Size</th>
                    <th>Price</th>
                    <th>Available</th>
                    <th width="40">Qty</th>
                    <th>Image</th>
                    <th>All</th>
                  </tr>

                </thead>

                <tbody>

                  {searchedProducts.map((item) => (
                    <React.Fragment key={item.id}>

                      <tr>

                        <td>
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <span
                                className="me-2 fw-bold text-primary mr-2"
                                role="button"
                                style={{ cursor: "pointer" }}
                                onClick={() => toggleHistory(item.product_id)}
                              >
                                {expandedRows[item.product_id] ? "▼" : "▶"}
                              </span>
                              <span>{item.product_code}</span>
                            </div>

                            <UncontrolledDropdown className="d-inline-block">
                              <DropdownToggle tag="span" style={{ cursor: "pointer", padding: "2px 6px" }}>
                                <i className="fa fa-ellipsis-v text-secondary"></i>
                              </DropdownToggle>
                              <DropdownMenu right>
                                <DropdownItem onClick={() => downloadRowPDF(item)}>
                                  <i className="fa fa-file-pdf-o text-danger mr-2"></i> Download as PDF
                                </DropdownItem>
                                <DropdownItem onClick={() => downloadRowExcel(item)}>
                                  <i className="fa fa-file-excel-o text-success mr-2"></i> Download as Excel
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                        </td>

                        <td>{item.product_name}</td>

                        <td>{item.gender}</td>

                        <td>{item.color}</td>

                        <td>{item.size_length}</td>

                        <td>₹ {item.price}</td>

                        <td>{item.qty}</td>

                        <td>

                          <input
                            type="text"
                            className="form-control text-center"
                            disabled={isViewMode}
                            style={{ width: "80px" }}
                            value={item.add_qty}
                            placeholder="Qty"
                            onChange={(e) => {
                              if (isViewMode) return;

                              const value = e.target.value;

                              if (!/^-?\d*$/.test(value)) {
                                return;
                              }

                              updateQty(item.product_id, value);
                            }}
                          />
                        </td>

                        <td className="text-center">

                          <img
                            src={getImage(item)}
                            alt=""
                            width="40"
                            height="40"
                            className="rounded border"
                          />

                        </td>

                        <td className="text-center">

                          <input
                            type="checkbox"
                            checked={item.checked || false}
                            disabled={isViewMode}
                            onChange={() => {
                              if (!isViewMode) {
                                toggleProduct(item.product_id);
                              }
                            }}
                          />

                        </td>

                      </tr>

                      {expandedRows[item.product_id] && (
                        <tr>

                          <td colSpan="10">

                            {/* History Table */}
                            {expandedRows[item.product_id] && (
                              <tr className="history-row">
                                <td colSpan="10">

                                  <table className="table table-bordered mb-0">
                                    <thead>
                                      <tr>
                                        <th>S.No</th>
                                        <th>Type</th>
                                        <th>From Branch</th>
                                        <th>To Branch</th>
                                        <th>Cancelled By  Branch</th>
                                        {/* <th>Staff Name</th> */}
                                        <th>Qty</th>
                                        <th>Current Qty</th>
                                        <th>Date Time</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {historyLoading[item.product_id] ? (
                                        <tr>
                                          <td colSpan="6" className="text-center">
                                            Loading...
                                          </td>
                                        </tr>
                                      ) : item.history.length === 0 ? (
                                        <tr>
                                          <td colSpan="6" className="text-center">
                                            No History Found
                                          </td>
                                        </tr>
                                      ) : (
                                        item.history.map((row, i) => (
                                          <tr key={i}>
                                            <td>{i + 1}</td>
                                            <td>{row.tran_type}</td>
                                            <td>{row.from_branch || "-"}</td>
                                            <td>{row.to_branch || "-"}</td>
                                            <td>{row.cancelled_branch || "-"}</td>
                                            {/* <td>{row.staff_name || "-"}</td> */}
                                            <td>{row.qty}</td>
                                            <td>{row.RunningStock}</td>
                                         <td>
  {formatDateTime(row.datetime)}
</td>
                                          </tr>
                                        ))
                                      )}
                                    </tbody>
                                  </table>

                                </td>
                              </tr>
                            )}

                          </td>

                        </tr>
                      )}

                    </React.Fragment>
                  ))}

                </tbody>

              </table>

            </div>

          </div>
        )}


        {/* Selected Products */}

        <div className="stockin-selected mt-4">

          <div className="stockin-selected-title d-flex justify-content-between align-items-center">
            <h5 className="mb-0 fw-bold">Selected Products</h5>

            <span className="badge bg-gray">
              {selected.length} Items
            </span>
          </div>

          <div className="table-responsive">

            <table className="table table-bordered table-hover align-middle stockin-table mb-0">

              <thead>

                <tr>
                  <th>Product Code</th>
                  <th>Name</th>
                  <th>Gender</th>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Price</th>
                  <th>Available Qty</th>
                  <th>Qty</th>
                  <th>Image</th>
                  {isViewMode ? null : <th width="60">Action</th>}
                </tr>

              </thead>

              <tbody>

                {selected.length === 0 ? (

                  <tr>
                    <td colSpan={isViewMode ? 8 : 9} className="text-center py-4 text-muted">
                      No Product Selected
                    </td>
                  </tr>

                ) : (

                  selected.map((item) => (

                    <tr key={item.id}>

                      <td>{item.product_code}</td>

                      <td>{item.product_name}</td>

                      <td>{item.gender}</td>

                      <td>{item.color}</td>

                      <td>{item.size_length}</td>

                      <td>₹ {item.price}</td>
                      <td>{item.qty}</td>
                      <td>
                        <span className="badge bg-success">
                          {item.add_qty}
                        </span>
                      </td>

                      <td className="text-center">

                        <img
                          src={
                            item.isImageUrl === true ||
                              item.isImageUrl === "true"
                              ? item.image_path
                              : item.url_image + item.image_path
                          }
                          alt=""
                          width="40"
                          height="40"
                          className="rounded border"
                        />

                      </td>

                      {isViewMode ? null : <td className="text-center">

                        <button
                          type="button"
                          className="btn btn-sm btn-danger"
                          disabled={isViewMode}
                          onClick={() => {
                            if (!isViewMode) {
                              toggleProduct(item.product_id);
                            }
                          }}
                        >
                          <i className="fa fa-trash"></i>
                        </button>

                      </td>}

                    </tr>

                  ))

                )}

              </tbody>

            </table>

          </div>

        </div>

        {/* Footer */}

        <div className="stockin-footer d-flex justify-content-end gap-3 mt-4">

          <button
            type="button"
            className="btn btn-outline-secondary px-4"
            onClick={() => history.goBack()}
          >
            {isViewMode ? "Back" : "Cancel"}
          </button>

          {!isViewMode && (
            <button
              type="button"
              className="btn btn-primary px-5"
              onClick={handleSave}
            >
              Save
            </button>
          )}
        </div>

      </div>

      {/* Negative Stock Confirmation Modal */}
      <Modal
        isOpen={negativeConfirmModal}
        toggle={handleCancelNegative}
        centered
        zIndex="99999"
      >
        <ModalHeader toggle={handleCancelNegative} className="bg-warning text-white">
          <i className="fa fa-exclamation-triangle mr-2"></i> Negative Quantity Warning
        </ModalHeader>
        <ModalBody className="p-4 text-center">
          <div className="mb-3">
            <i
              className="fa fa-exclamation-circle text-warning"
              style={{ fontSize: "48px" }}
            ></i>
          </div>
          <h5 className="font-weight-bold mb-2">
            You are going to add negative quantity.
          </h5>
          <p className="text-muted mb-0">
            Are you sure you want to proceed with negative stock adjustment?
          </p>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button
            color="secondary"
            onClick={handleCancelNegative}
            className="px-4"
          >
            Cancel
          </Button>
          <Button
            color="warning"
            onClick={handleConfirmNegative}
            className="px-4 font-weight-bold"
          >
            Yes, Proceed
          </Button>
        </ModalFooter>
      </Modal>

    </div>
  );
}